import { render, staticRenderFns } from "./UploadResource.vue?vue&type=template&id=717dc866&scoped=true"
import script from "./UploadResource.vue?vue&type=script&lang=js"
export * from "./UploadResource.vue?vue&type=script&lang=js"
import style0 from "./UploadResource.vue?vue&type=style&index=0&id=717dc866&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717dc866",
  null
  
)

export default component.exports